import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { KindeAngularService } from 'kinde-angular';
import { Observable } from 'rxjs';
import { exhaustMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  private authService = inject(KindeAngularService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.authService.accessToken$.pipe(
      take(1),
      exhaustMap((token) => {
        if (!token) {
          return next.handle(req);
        }

        if (req.headers?.get('Authorization')?.length > 0) {
          return next.handle(req);
        }

        const modifiedrequest = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });
        return next.handle(modifiedrequest);
      })
    );
  }
}
